import type { ThemeColors } from '../../../../tokens/colors/types';
import { border } from './border';
import { divider } from './divider';
import { blue, green, neutral, orange, pale, purple, red } from './palette';
import { deals, retail } from './product';
import { critical, info, positive, shout, warning } from './semantic';
import { typography } from './typography';

const primary: ThemeColors['primary'] = {
  '50': '#006D85',
  '10': '#F2FCFF',
  '20': '#E5FAFF',
  '30': '#63CCE3',
  '70': '#005466',
  '80': '#004352',
  '90': '#004352',
};

const secondary: ThemeColors['secondary'] = {
  '20': '#60BEBE',
  '30': '#60BEBE',
  '50': '#60BEBE',
  '70': '#60BEBE',
  '90': '#60BEBE',
};

const baseColors: ThemeColors = {
  blue,
  green,
  red,
  orange,
  primary,
  secondary,
  purple,
  neutral,
  pale,
  info,
  warning,
  critical,
  positive,
  deals,
  retail,
  shout,
  border,
  divider,
  typography,
};

export default baseColors;
